import ActionButton from '@able/react/dist/ActionButton';
import { AbleCommonProps } from "../Types";
import usePaginate, { PageProps } from "./usePaginate";

export type PaginationLoadMoreProps = {
    variant: 'MediumEmphasis' | 'LowEmphasis';
    /** This will be attached to aria-label */
    label?: string;
    customClass?: string;
} & PageProps & AbleCommonProps;

/**
 * PaginationLoadMore is a component can be used in Table or Individually
 *
 *
 * @version 1.0.0
 */

const PaginationLoadMore = (props: PaginationLoadMoreProps) => {
    const { variant, onPageChange, developmentUrl, page, pageSize, totalRecords, label = "Pagination", customClass = '' } = props;

    const { nextPage, pages } = usePaginate({
        type: 'load-more',
        page,
        totalRecords,
        pageSize,
        onPageChange
    });

    const isInfinite = totalRecords === 0;

    if (!['MediumEmphasis', 'LowEmphasis'].includes(variant)) {
        throw new Error("PaginationLoadMore variant is invalid, use between MediumEmphasis, LowEmphasis");
    }

    const loadNextPage = () => {
        nextPage();
    }

    const pageEnds = !isInfinite && page === pages ? 'Page ends' : '';

    const ariaLabel: React.AriaAttributes = {
        'aria-label': `Load more, current page ${page}, ${pageEnds}`,
    }


    return <nav className={`ted-ui-pagination-load-more${customClass ? ` ${customClass}` : ''}`} aria-label={label}>
        <ActionButton element={'button'} variant={variant} label={'Load more'}  icon='Load' developmentUrl={developmentUrl} events={{
            onClick: loadNextPage
        }} {...ariaLabel} data-testid="loadMore" ariaDisabled={Boolean(pageEnds)}/>
    </nav>
}

export default PaginationLoadMore;
